import React, { useEffect, useState } from "react";
import { Button, Card, ListGroup, ListGroupItem } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import useProducts from "../../hooks/useProducts";
import "./ManageProduct.css";

const ManageProduct = () => {
  const [product, setProduct] = useState({});
  const [products, setProducts] = useProducts();
  useEffect(() => {
    const url = `https://nameless-earth-37809.herokuapp.com/product/${productId}`;
    fetch(url)
      .then((res) => res.json())
      .then((data) => setProduct(data));
  }, [products]);
  const { name, img, supplier, description } = product;
  const { productId } = useParams();

  const handleDelivered = (e) => {
    e.preventDefault();

    const quantityValue = +e.target.quantity.value;
    if (quantityValue >= 1) {
      const quantity = +e.target.quantity.value - 1;
      const soldValue = +e.target.sold.value + 1;
      const updatedProduct = {
        quantity,
        sold: soldValue,
      };

      // !Send data for update Delivered
      const url = `https://nameless-earth-37809.herokuapp.com/product/${productId}`;
      fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedProduct),
      })
        .then((response) => response.json())
        .then((data) => {
          const updateQuantity = products.find((p) => p._id === productId);
          setProduct(updateQuantity);
        });
    } else {
    }
  };

  const handleQuantity = (e) => {
    e.preventDefault();
    const adding = e.target.addQuantity.value;
    const previousQuantity = product.quantity;
    const quantity = +previousQuantity + +adding;
    const updatedProduct = { name, img, supplier, description, quantity };

    // !Send data for update Sold
    const url = `https://nameless-earth-37809.herokuapp.com/product/${productId}`;
    fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedProduct),
    })
      .then((response) => response.json())
      .then((data) => {
        const updateQuantity = products.find((p) => p._id === productId);
        setProduct(updateQuantity);
        e.target.addQuantity.value = "";
      });
  };

  return (
    <div className="container item-container pt-5">
      <Link
        className="text-center btn btn-success w-50 mx-auto d-block mt-5 fw-bold"
        as={Button}
        to={`/manageInventory`}
      >
        Manage Inventory
      </Link>
      <div className="container d-flex justify-content-center align-items-center pt-3 mb-3 pb-3">
        <Card style={{ width: "500px" }}>
          <div className="d-flex justify-content-center align-items-center flex-column">
            {" "}
            <small>
              <strong>ID: {product._id}</strong>{" "}
            </small>
            <Card.Img className="w-50" variant="top" src={product.img} />
          </div>
          <Card.Body>
            <Card.Title>{product.name}</Card.Title>
            <Card.Text>
              <small>{product.description}</small>
            </Card.Text>
          </Card.Body>
          <ListGroup className="list-group-flush">
            <ListGroupItem>
              {product.quantity === 0 ? "Out of Stock" : "In Stock"}{" "}
              <form onSubmit={handleDelivered}>
                <input
                  readOnly
                  className="w-25 border-0"
                  disabled
                  type="number"
                  name="quantity"
                  value={product.quantity}
                  id=""
                />
                <input
                  type="submit"
                  value="Delivered"
                  className="btn btn-primary"
                ></input>
                <small className=" ms-2">
                  {" "}
                  <strong>Sold:</strong>{" "}
                </small>
                <input
                  className="w-25 border-0"
                  disabled
                  type="number"
                  name="sold"
                  value={product.sold}
                />
              </form>
            </ListGroupItem>
            <ListGroupItem>
              Price : <strong>{product.price}</strong>{" "}
            </ListGroupItem>
            <ListGroupItem>
              Supplier: <em> {product.supplier}</em>{" "}
            </ListGroupItem>
          </ListGroup>
          <Card.Body>
            <ListGroupItem>
              <small>
                <strong>Add To Stock :</strong>
              </small>
              <form onSubmit={handleQuantity}>
                <input
                  className="w-25 mt-2"
                  min="1"
                  step="1"
                  required
                  type="number"
                  name="addQuantity"
                />
                <input
                  type="submit"
                  value="Add Product Quantity"
                  className="btn btn-primary mt-2 d-block"
                ></input>
              </form>
            </ListGroupItem>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default ManageProduct;
